import React from "react";
import ProgramRouter from './Program/Router';
export { getFields, getReplyFields } from './Program/Router';

export default function PaymentSupplierRouter(props){
    return <ProgramRouter {...props} mode='SUPPLIER' />;
}